export default __webpack_public_path__ + "static/media/microPhone.44a89ef4.svg";